import { render, staticRenderFns } from "./NestedDropdownSubmenu.vue?vue&type=template&id=dc5df260&"
import script from "./NestedDropdownSubmenu.vue?vue&type=script&lang=js&"
export * from "./NestedDropdownSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports